import Box from '@mui/material/Box';
import { styled } from '@mui/material/styles';

const StyledBoxCenter = styled(Box)(() => ({
  textAlign: 'center',
  marginTop: '10rem',
  minHeight: 'calc(100vh - 15.4rem)'
}));

export default StyledBoxCenter;
